import styled, { createGlobalStyle } from 'styled-components';
import media from 'src/styles/Media.styled';
import { 
    DARK_NAVY_FONT_COLOR,  
    FONT_FAMILY_DEMI, 
    SEMANTIC_TEXT_PX, 
    TITLE_FONT_COLOR,
    SECONDARY_FONT_COLOR,
    DISABLED_FONT_COLOR
} from 'src/styles/fonts/MCFontConstants';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';

export const FilterPopup = styled.div.attrs({ 'data-filter-popup': '' })`
    position: absolute;
    top: calc(100% + 8px);
    right: -5px;
    z-index: 1000;
    background: #f5f5f5;
    box-shadow: 0px 0px 6px #00000029;
    width: 390px;
    height: ${({ bannerHeight }) => bannerHeight ? `calc(78vh - ${bannerHeight})` : '78vh'};
    display: flex;
    flex-direction: column;
    border-radius: 6px;
    overflow: hidden;

    ${media.mediumDevice`
        width: 360px;
    `}

    ${media.mobileDevice`
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        width: 100vw;
        min-width: 100vw;
        max-width: none;
		height: ${({viewportHeight}) => viewportHeight ? `${viewportHeight}px` : '100vh'} !important;
        border-radius: 0;
        padding-bottom: ${({ bannerHeight }) => bannerHeight ? '0px' : '80px'};
        z-index: 200000;
    `}
    @media only screen and (min-width: 810px) and (max-width: 180px) and (orientation: landscape) {
        height: 73vh !important;
    }
`;

export const FilterHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-left: 16px;
    margin-top: 11px;
    margin-right: 16px;
    margin-bottom: 7px;
    
    ${media.mobileDevice`
        margin-bottom: 15px;
    `}
`;

export const FilterHeading = styled.p`
    color: ${DARK_NAVY_FONT_COLOR};
    font-size: 24px;
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0;
    letter-spacing: 0;
`;

export const Reset = styled.p`
    color: ${({ disabled }) => disabled ? DISABLED_FONT_COLOR : TITLE_FONT_COLOR};
    font-size: ${SEMANTIC_TEXT_PX};
    font-family: ${FONT_FAMILY_DEMI};
    margin: 0;
    padding-right: 1.3em;
    align-self: center;
    pointer-events: ${({ disabled }) => disabled ? 'none' : 'auto'};
    opacity: ${({ disabled }) => disabled ? 0.5 : 1};
    &:hover {
        cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
    }
`;

export const FilterContent = styled.div`
    display: flex;
    flex-direction: column;
    ${scrollBarStyle}
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    background: #f5f5f5;
    gap: 0;
    padding: 0;
    padding-top: 8px;
    
    ${media.mobileDevice`
       padding-bottom: calc(50dvh + env(safe-area-inset-bottom));
    `}
    
    @media only screen and (min-height: 800px) and (max-width: 430px) {
        padding-bottom: 250px;
    }
`;

export const LocationFilterWrapper = styled.div`
    background: white;
    margin-left: 16px;
    margin-right: 16px;
    margin-bottom: 10px;
    padding: 19px 16px;
    border-radius: 6px;
    box-shadow: 0px 0px 6px #00000029;
`;

export const LocationHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    margin-bottom: ${({ isExpanded }) => isExpanded ? '16px' : '0'};
`;

export const LocationHeaderLeft = styled.div`
    display: flex;
    align-items: center;
`;

export const LocationTitle = styled.div`
    font-family: ${FONT_FAMILY_DEMI};
    font-size: 15px;
    color: ${DARK_NAVY_FONT_COLOR};
    letter-spacing: 0;
`;

export const LocationBadge = styled.div`
    width: 8px;
    height: 8px;
    background-color: ${TITLE_FONT_COLOR};
    border-radius: 50%;
    display: ${({ show }) => show ? 'block' : 'none'};
`;

export const LocationChevron = styled.img`
    transform: ${({ isExpanded }) => isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'};
`;

export const LocationContent = styled.div`
    display: ${({ isExpanded }) => isExpanded ? 'flex' : 'none'};
    flex-direction: column;
    gap: 12px;
`;

export const LocationRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const LocationLabel = styled.div`
    font-family: ${FONT_FAMILY_DEMI};
    font-size: 14px;
    color: ${SECONDARY_FONT_COLOR};
    letter-spacing: 0;
`;

export const SelectWrapper = styled.div`
    width: 100%;

    .location-filter-select.p-dropdown .p-dropdown-label {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 28px;
        box-sizing: border-box;
    }

    .location-filter-select--territory.p-dropdown .p-dropdown-label {
        display: block;
        width: calc(100% - 64px);
        padding-right: 20px;
    }

    .location-filter-select.p-dropdown .p-dropdown-label > * {
        min-width: 0;
        max-width: 100%;
    }

    .location-filter-select.p-dropdown .p-dropdown-clear-icon {
        right: 2rem;
    }
`;

export const LocationFilterPanelStyles = createGlobalStyle`
    .location-filter-panel .p-dropdown-items .p-dropdown-item {
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .location-filter-panel .p-dropdown-items .p-dropdown-item > * {
        min-width: 0;
        max-width: 100%;
    }
`;

export const AccountOptionRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    padding: 10px 16px;
`;

export const AccountOptionName = styled.span`
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: #140f4b;
    font-family: AvenirNextWorld Regular;
`;

export const AccountOptionNumber = styled.span`
    flex-shrink: 0;
    text-align: right;
    white-space: nowrap;
    font-size: 14px;
    color: #140f4b;
    font-family: AvenirNextWorld Regular;
`;

export const TerritoryValueText = styled.span`
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
